/* Tri-tennis: "Make it complete" – accessoires aanvinken (mee met Add to cart) of los toevoegen */
(function () {
  var box = document.getElementById('TTComplete');
  if (!box || box.__tt) return;
  box.__tt = true;
  var root = (box.getAttribute('data-root') || '/').replace(/\/?$/, '/');
  var cartUrl = box.getAttribute('data-cart-url') || '/cart';
  var status = box.querySelector('[data-tt-cp-status]');

  /* Plaats: direct boven de voordelen-blokjes (die komen dus onder "Make it complete"), anders onder de koopknop */
  function place() {
    var info = document.querySelector('.product__info-container');
    if (!info) return false;
    var icons = info.querySelector('.icon-with-text');
    var anchor = icons || info.querySelector('product-form') || info.querySelector('.product-form');
    if (anchor) {
      var blk = anchor;
      while (blk.parentElement && blk.parentElement !== info) blk = blk.parentElement;
      blk.insertAdjacentElement(icons ? 'beforebegin' : 'afterend', box);
    } else {
      info.appendChild(box);
    }
    box.hidden = false;
    return true;
  }
  if (!place()) return;

  function variantOf(item) { var el = item.querySelector('[data-tt-cp-variant]'); return el ? parseInt(el.value, 10) : 0; }
  function msg(t, err) { status.textContent = t; status.classList.toggle('is-err', !!err); }
  function bumpCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (s) { s.textContent = c.item_count; });
    }).catch(function () {});
  }
  function add(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); });
  }

  box.querySelectorAll('[data-tt-cp-item]').forEach(function (item) {
    var cb = item.querySelector('[data-tt-cp-check]');
    cb.addEventListener('change', function () { item.classList.toggle('is-checked', cb.checked); });
    var btn = item.querySelector('[data-tt-cp-add]');
    btn.addEventListener('click', function () {
      var id = variantOf(item); if (!id) return;
      btn.disabled = true;
      add([{ id: id, quantity: 1 }]).then(function () {
        btn.disabled = false; btn.classList.add('is-done');
        btn.querySelector('span').textContent = box.getAttribute('data-added') || 'Added';
        cb.checked = false; item.classList.remove('is-checked');
        msg(box.getAttribute('data-msg') || '✓ Added to your cart.');
        bumpCount();
      }).catch(function (e) { btn.disabled = false; msg(e.message, true); });
    });
  });

  /* Hoofdknop "Add to cart": aangevinkte accessoires gaan mee */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('product-form') || !form.closest('.product__info-container')) return;
    var checked = [].slice.call(box.querySelectorAll('[data-tt-cp-item]')).filter(function (i) { return i.querySelector('[data-tt-cp-check]').checked; });
    if (!checked.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var fd = new FormData(form);
    var main = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 };
    var props = {};
    fd.forEach(function (val, key) { var m = key.match(/^properties\[(.+)\]$/); if (m && typeof val === 'string' && val !== '') props[m[1]] = val; });
    if (Object.keys(props).length) main.properties = props;
    var items = [main].concat(checked.map(function (i) { return { id: variantOf(i), quantity: 1 }; }));
    var sub = form.querySelector('[type="submit"]');
    if (sub) { sub.setAttribute('aria-disabled', 'true'); sub.classList.add('loading'); }
    add(items).then(function () { window.location.href = cartUrl; }).catch(function (err) {
      if (sub) { sub.removeAttribute('aria-disabled'); sub.classList.remove('loading'); }
      msg(err.message, true);
    });
  }, true);
})();